import $ from 'jquery';

/**
 * Handle scrolling to anchor elements
 *
 * @type {AsyncDynamicInitFunction<HTMLElement>}
 */
export default async ($collection) => {

	for (const select of $collection) {
		const $select = $(select);
		$select.off('change.floating-placeholder').on('change.floating-placeholder', e => {
			const $label = $select.parent().find('.form-label');
			/** @type {HTMLSelectElement} */ // @ts-ignore
			const target = e.currentTarget;
			$label.css({
				color: target.value ? '' : 'var(--mp-input-placeholder-color)',
				transform: target.value ? '' : 'translateY(-50%)',
			});
		});
		$select.triggerHandler('change.floating-placeholder');
	}
};